import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'node',
  templateUrl: './node.component.html',
  styleUrls: ['./node.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NodeComponent implements OnInit {
  @Input() name: string;
  @Input() children = [];
  @Input() bg_color;
  @Input() owner_profile_image_path;
  @Input() owner_type;
  @Input() position_value;
  constructor() {}

  ngOnInit(): void {}
}
